import React from 'react';
import { IconProps } from './types';

const PlusIcon = ({ className }: IconProps): React.ReactElement => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 2h-1.5v5.25H2v1.5h5.25V14h1.5V8.75H14v-1.5H8.75V2z"
    />
  </svg>
);

export default PlusIcon;
